import { render } from "./User_Service_Request.vue?vue&type=template&id=fb60ec20"
import script from "./User_Service_Request.vue?vue&type=script&lang=js"
export * from "./User_Service_Request.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__